import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import '../styles/components/navbar.css';

export default function Navbar({ onNavigate, showAdminLink = false }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = (path) => {
    setMenuOpen(false);
    onNavigate(path);
  };

  const handleSectionClick = (section) => handleNavClick(`/#${section}`);

  return (
    <header className="site-header">
      <div className="site-header__bar">
        <a
          href="/"
          onClick={(event) => { event.preventDefault(); handleNavClick('/'); }}
          className="site-header__brand"
        >
          <img
            src="/images/logo.png"
            alt="Aurora Projectos"
            className="site-header__logo"
          />
        </a>

        {/* Mobile Menu Toggle Button */}
        <button
          className="menu-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-label="Abrir menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>

        <nav aria-label="Navegação principal" className={`site-nav ${menuOpen ? 'is-open' : ''}`}>
          <a href="/#estudio" onClick={(event) => { event.preventDefault(); handleSectionClick('estudio'); }} className="site-nav__link">Estúdio</a>
          <a href="/#projetos" onClick={(event) => { event.preventDefault(); handleSectionClick('projetos'); }} className="site-nav__link">Projetos</a>
          <a href="/#servicos" onClick={(event) => { event.preventDefault(); handleSectionClick('servicos'); }} className="site-nav__link">Serviços</a>
          <a href="/#processo" onClick={(event) => { event.preventDefault(); handleSectionClick('processo'); }} className="site-nav__link">Processo</a>
          {showAdminLink && (
            <a href="/admin" onClick={(event) => { event.preventDefault(); handleNavClick('/admin'); }} className="site-nav__link site-nav__link--admin">
              Painel Admin
            </a>
          )}
          <a href="/#contato" onClick={(event) => { event.preventDefault(); handleSectionClick('contato'); }} className="btn btn--outline btn--sm">
            Fale com o estúdio
          </a>
        </nav>
      </div>
    </header>
  );
}
